import ChecklistIcon from '@mui/icons-material/Checklist';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BooleanField, BooleanInput, Create, Datagrid, Edit, EditButton, FormTab, List, NumberField, NumberInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import OptionReferenceField from 'utils/GeneratedRaReference/OptionReferenceField';
import OptionReferenceInput from 'utils/GeneratedRaReference/OptionReferenceInput';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
// import { GrapesjsInputButton } from 'utils/react-admin/inputs/GrapesjsInput';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import RichTextInputEx from 'utils/react-admin/inputs/RichTextInputEx';
import { Permissions } from '../../ra-php-crud-api-auth';
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <NumberInput source="position" fullWidth />,
  <OptionReferenceInput source="reading_sub_category_id" fullWidth filter={{ option_type: 'reading_sub_category' }} />,
  <TextInput source="title_en" fullWidth />,
  <TextInput source="title_tc" fullWidth />,
  <TextInput source="title_sc" fullWidth />,
  <TextInput source="description_en" fullWidth />,
  <TextInput source="description_tc" fullWidth />,
  <TextInput source="description_sc" fullWidth />,
  <TextInput source="journal_en" fullWidth />,
  <TextInput source="journal_tc" fullWidth />,
  <TextInput source="journal_sc" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateIsPublic: any[] = [required()];
const validatePosition: any[] = [];
const validateReadingSubCategoryId: any[] = [required()];
const validateTitleEn: any[] = [];
const validateTitleTc: any[] = [];
const validateTitleSc: any[] = [];
// const validateDescriptionEn: any[] = [];
// const validateDescriptionTc: any[] = [];
// const validateDescriptionSc: any[] = [];
const validateJournalEn: any[] = [];
const validateJournalTc: any[] = [];
const validateJournalSc: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.title_tc} (#${record.id})`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <NumberField source="position" fullWidth />
            <OptionReferenceField source="reading_sub_category_id" fullWidth />
            <TextField source="title_en" fullWidth />
            <TextField source="title_tc" fullWidth />
            <TextField source="title_sc" fullWidth />
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <NumberField source="position" fullWidth />
        <OptionReferenceField source="reading_sub_category_id" fullWidth />
        <TextField source="title_en" fullWidth />
        <TextField source="title_tc" fullWidth />
        <TextField source="title_sc" fullWidth />
        <TextField source="description_en" fullWidth />
        <TextField source="description_tc" fullWidth />
        <TextField source="description_sc" fullWidth />
        <TextField source="journal_en" fullWidth />
        <TextField source="journal_tc" fullWidth />
        <TextField source="journal_sc" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean}) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><BooleanInput source="is_public" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={6}><NumberInput source="position" fullWidth validate={validatePosition} /></Grid>
          <Grid item xs={12}><OptionReferenceInput source="reading_sub_category_id" fullWidth filter={{ option_type: 'reading_sub_category' }} validate={validateReadingSubCategoryId} /></Grid>
          <Grid item xs={4}><TextInput source="title_en" fullWidth validate={validateTitleEn} /></Grid>
          <Grid item xs={4}><TextInput source="title_tc" fullWidth validate={validateTitleTc} /></Grid>
          <Grid item xs={4}><TextInput source="title_sc" fullWidth validate={validateTitleSc} /></Grid>
          <Grid item xs={12}><RichTextInputEx source="description_en" /></Grid>
          <Grid item xs={12}><RichTextInputEx source="description_tc" /></Grid>
          <Grid item xs={12}><RichTextInputEx source="description_sc" /></Grid>
          <Grid item xs={4}><TextInput source="journal_en" fullWidth validate={validateJournalEn} /></Grid>
          <Grid item xs={4}><TextInput source="journal_tc" fullWidth validate={validateJournalTc} /></Grid>
          <Grid item xs={4}><TextInput source="journal_sc" fullWidth validate={validateJournalSc} /></Grid>
        </GridWrapper>
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: ChecklistIcon,
}

export default Resource;
